import {
  RadioSelect,
  RangeSlider,
  Select,
  TextArea,
  TextInput,
  VehicleProps,
  VehicleSchema,
  useOptions
} from "@fla/components";
import VehicleIcon from "@fla/components/src/assets/svgs/vehicle.svg";
import { yupResolver } from "@hookform/resolvers/yup";
import { selectConsentOrdersBase } from "pages/ConsentOrders";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

interface IProps {
  formId: string;
  store: VehicleProps;
  onSubmit: (values: VehicleProps) => void;
}

const Details: FC<IProps> = ({ formId, store, onSubmit }) => {
  const { initialDetails } = useSelector(selectConsentOrdersBase);

  const { ownerV2Options, saleProceedsOptions, splitByOptions } = useOptions({ initialDetails });

  const { handleSubmit, control, watch, setValue } = useForm({
    mode: "all",
    defaultValues: store,
    resolver: yupResolver(VehicleSchema)
  });

  return (
    <form id={formId} className="space-y-5" onSubmit={handleSubmit(onSubmit)}>
      <div className="my-8 flex flex-col items-center justify-center">
        <img src={VehicleIcon} className="w-10 h-auto my-3" alt="bank" />
        <h3 className="font-bold">Motor Vehicles</h3>
      </div>
      <TextInput
        title="Make, Model & Year"
        control={control}
        name="make_model_year"
        id="make_model_year"
        placeholder="Eg 2013 Toyota Corolla"
      />

      <TextInput
        title="Registration"
        control={control}
        name="registration"
        id="registration"
        placeholder="Eg eg 845 HGE or “unregistered’"
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <Select
        title="In whose name is this vehicle in?"
        control={control}
        name="owner"
        id="owner"
        placeholder="Select"
        options={ownerV2Options}
      />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />

      <TextInput title="Approx Value" control={control} name="value" id="value" placeholder="" isAmount />

      <hr className="mt-7 mb-10 bg-gray-500 w-full" />
      <RadioSelect
        title="What happens to this"
        type="card-brief"
        name="split_by"
        id="split_by"
        control={control}
        options={splitByOptions.filter(option => option.value !== "percentage") as []}
        classes="my-8"
        onChange={() => {
          setValue("sale_proceeds", "");
          setValue("percentage", { user: "", spouse: "" });
        }}
      />

      {watch("split_by") === "sell" ? (
        <RadioSelect
          title="How will the net sale proceeds be divided"
          type="card-brief"
          name="sale_proceeds"
          id="sale_proceeds"
          control={control}
          options={saleProceedsOptions as []}
          classes="my-8"
          onChange={v => {
            if (v === "percentage") {
              setValue("percentage", { user: "50", spouse: "50" });
            }
          }}
        />
      ) : null}

      {watch("sale_proceeds") === "percentage" ? (
        <RangeSlider
          title="Split By A Percentage"
          control={control}
          name="percentage.user"
          id="percentage.user"
          exName={initialDetails?.spouse?.first_name || "N/A"}
          percentageOf={watch("value")}
          onChange={val => {
            setValue("percentage.spouse", `${100 - Number(val)}`);
          }}
        />
      ) : null}

      <TextArea
        title="Further comments you want us to know about this (optional)"
        control={control}
        name="comment"
        id="comment"
        placeholder="Description"
      />
    </form>
  );
};
export default Details;
